import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AppMainService } from 'src/app/app-main.service';
import { ReportsFinanceLabelName, ReportsFinanceNames, ReportsFinanceReportNames, ReportsFinanceRoutes } from '../../models/reports-finance.models';
import { ReportService } from '../../reportService';
import { AppMainComponent } from 'src/app/app.main.component';
import * as moment from 'moment';
import { MessageService } from 'primeng/api';
import { IReportsColumnModel } from '../../models/reports.models';
import { IReportsFilterModel } from '../../models/reports-filter.models';
import { ParseHelper } from 'src/app/modules/shared/parse.helper';
import { DataService } from '../../dataService';
import { IReportsDataServiceLeftMenuExpantionModel, IReportsDataServiceTopMenuModel, ReportsDataServiceModelValues, ReportsTopMenuItemsValues } from '../../models/reports-data-service-model';
import { DatePipe } from '@angular/common';
import { DateFilterType } from 'src/app/models/date-range/get-date-range.models';
import { ReportType } from 'src/app/finance/constants/constants';
import { FinanceService } from 'src/app/finance/finance.service';


@Component({
  selector: 'app-reports-finance',
  templateUrl: './reports-finance.component.html',
  styleUrls: ['./reports-finance.component.scss']
})
export class ReportsFinanceComponent implements OnInit, OnDestroy {

  protected ngUnsubscribe$: Subject<void> = new Subject<void>();
  public reportName: string = '';
  public selectedWindow: string = '';
  dateFrom: any = this.app._showDateTimeWithZone(new Date());
  dateTo: any = this.app._showDateTimeWithZone(new Date());
  public reportDate: any;
  public organizationName = "";
  public pageSize = 15;
  public pageNumber = 1;
  public Months: any[] = [];

  public cols: IReportsColumnModel[] = [];
  channelList: any[] = [];
  selectedChannel;
  public reportDatas: any[] = [];
  public reportDatasCopy = [];
  public filterByInputValue: any[] = [];
  selectedFilterVm: IReportsFilterModel[];
  selectedDateFilter = { label: 'Today', code: 'today' };

  profitReport: any[] = [];
  totalIncome = 0;
  totalCOGS = 0;
  totalExpense = 0;
  grossProfit = 0;
  netIncome = 0;
  tranTemp: any;
  expandedRows: {} = {};
  displayBalanceDetail = false;
  transactionDetails: any[] = [];
  dataPassed: any;
  tableShowMore: number[] = [15, 30, 50, 100];
  currentPageNo: number;
  totalDetailRecord: number;
  displaySetting = false;
  first;
  columns = [
    { id: 1, name: "Year" },
    { id: 2, name: "Quarter" },
    { id: 3, name: "Month" },
    { id: 4, name: "Week" },
    { id: 5, name: "Vendor" },
    { id: 6, name: "Rep" },
    { id: 7, name: "Class" },
    { id: 8, name: "Item Type" },
    { id: 9, name: "Product Category" },
    { id: 10, name: "Item No." },
    { id: 11, name: "Location" },
    { id: 12, name: "Shipping Method" },
    { id: 13, name: "Payment Method" },

  ]
  selectedColumn;
  selectedOrder = "desc";
  isAscending = false;
  orderOptions: any[] = [
    { name: "ASC", value: "asc" },
    { name: "DESC", value: "desc" },
  ];
  constructor(
    private router: ActivatedRoute,
    private appMainService: AppMainService,
    private reportService: ReportService,
    private app: AppMainComponent,
    private messageService: MessageService,
    private dataService: DataService,
    private datePipe: DatePipe,
    private financeService: FinanceService,

  ) { }

  async ngOnInit() {
    this.organizationName = this.app.user.organizationName;

    this.router.paramMap.pipe(takeUntil(this.ngUnsubscribe$)).subscribe((param: any) => {
      this.appMainService.isHideSpinner(this.reportName);
      const activityType = param.params.type;
      this.channelList = [];
      this.selectedChannel = null;
      this.cols = [];
      this.reportDatas = [];
      this.reportDatasCopy = [];

      switch (activityType) {
        case ReportsFinanceRoutes.incomeExpenseGraph:
          this.selectedWindow = "incomeExpenseGraph";
          break;
        case ReportsFinanceRoutes.pLStatement:
          this.selectedWindow = ReportsFinanceNames.pLStatement;
          this.reportName = ReportsFinanceReportNames.pLStatement;
          break;
        case ReportsFinanceRoutes.balance:
          this.selectedWindow = ReportsFinanceNames.balance;
          this.reportName = ReportsFinanceReportNames.balance;
          break;
        default:
          break;
      }
      this.dataService.sendData<IReportsDataServiceLeftMenuExpantionModel>({ actionType: ReportsDataServiceModelValues.reportsLeftMenuExpansion, value: this.selectedWindow });

      //Get Report  data
      this.getFinanceReportData();

      //default should be this month for p&l
      if (this.selectedWindow == 'pLStatement') {
        this.selectedDateFilter = {
          label: 'This Month',
          code: 'this month'
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.ngUnsubscribe$) {
      this.ngUnsubscribe$.next();
      this.ngUnsubscribe$.complete();
      this.ngUnsubscribe$.unsubscribe();
    }
  }
  getFinanceReportData(applyFilter: boolean = false) {
    switch (this.selectedWindow) {
      case ReportsFinanceNames.pLStatement:
        this.getAllProfitLossReport();
        break;
      case ReportsFinanceNames.balance:
        this.getAllFinanceReport();
        break;
      default:
        break;
    }
  }
  getAllFinanceReport() {
    switch (this.selectedWindow) {
      case ReportsFinanceNames.balance:
        this.profitReport = [
          {
            "id": 1,
            "financialAccountName": "Assets",
            "financialAccountId": 1,
            "order": 1,
            "parentFinancialAccountId": 0,
            "balance": 0,
            "showChildren": true,
            "childAccounts": [
              {
                "id": 1,
                "financialAccountName": "Current Assets",
                "financialAccountId": 11,
                "order": 1,
                "parentFinancialAccountId": 1,
                "balance": 0,
                "childAccounts": [
                  {
                    "id": 1,
                    "financialAccountName": "Checking & Saving",
                    "financialAccountId": 111,
                    "order": 1,
                    "parentFinancialAccountId": 11,
                    "balance": 0,
                  },
                  {
                    "id": 2,
                    "financialAccountName": "Account Receivable",
                    "financialAccountId": 112,
                    "order": 2,
                    "parentFinancialAccountId": 11,
                    "balance": 0,
                  },
                  {
                    "id": 3,
                    "financialAccountName": "Other Current Assets",
                    "financialAccountId": 113,
                    "order": 3,
                    "parentFinancialAccountId": 11,
                    "balance": 0,
                  },
                ],
                "showChildren": true,
              },
              {
                "id": 2,
                "financialAccountName": "Fixed Assets",
                "financialAccountId": 12,
                "order": 2,
                "parentFinancialAccountId": 1,
                "balance": 0,
                "childAccounts": [
                  {
                    "id": 1,
                    "financialAccountName": "1700 - Accumulated Depreication",
                    "financialAccountId": 121,
                    "order": 1,
                    "parentFinancialAccountId": 12,
                    "balance": 0,
                  },
                ],
                "showChildren": true,
              },
            ]
          },
          {
            "id": 2,
            "financialAccountName": "Liabilities & Equity",
            "financialAccountId": 2,
            "order": 2,
            "parentFinancialAccountId": 0,
            "balance": 0,
            "showChildren": true,
            "childAccounts": [
              {
                "id": 1,
                "financialAccountName": "Liabilities",
                "financialAccountId": 21,
                "order": 1,
                "parentFinancialAccountId": 1,
                "balance": 0,
                "childAccounts": [
                  {
                    "id": 1,
                    "financialAccountName": "Current Liabilities",
                    "financialAccountId": 211,
                    "order": 1,
                    "parentFinancialAccountId": 21,
                    "balance": 0,
                  },
                  {
                    "id": 2,
                    "financialAccountName": "Accounts Payable",
                    "financialAccountId": 212,
                    "order": 2,
                    "parentFinancialAccountId": 21,
                    "balance": 0,
                  },
                  {
                    "id": 3,
                    "financialAccountName": "Long Term Liabilities",
                    "financialAccountId": 213,
                    "order": 3,
                    "parentFinancialAccountId": 21,
                    "balance": 0,
                  },
                  {
                    "id": 4,
                    "financialAccountName": "Credit Card",
                    "financialAccountId": 214,
                    "order": 4,
                    "parentFinancialAccountId": 21,
                    "balance": 0,
                  },
                ],
                "showChildren": true,
              },
              {
                "id": 2,
                "financialAccountName": "Equity",
                "financialAccountId": 22,
                "order": 2,
                "parentFinancialAccountId": 2,
                "balance": 0,
                "childAccounts": [
                  {
                    "id": 1,
                    "financialAccountName": "Opening Balance Equity",
                    "financialAccountId": 221,
                    "order": 1,
                    "parentFinancialAccountId": 22,
                    "balance": 0,
                  },
                  {
                    "id": 2,
                    "financialAccountName": "Members Equity",
                    "financialAccountId": 222,
                    "order": 2,
                    "parentFinancialAccountId": 22,
                    "balance": 0,
                  },
                  {
                    "id": 3,
                    "financialAccountName": "Net Income",
                    "financialAccountId": 223,
                    "order": 3,
                    "parentFinancialAccountId": 22,
                    "balance": 0,
                  },
                ],
                "showChildren": true,
              },
            ]
          },
        ];
        //this.getBalanceSheet();
        break;
      default:
        break;
    }
    this.profitReport.forEach((s) => {
      this.expandedRows[s.financialAccountId] = true;
    });
  }
  getAllProfitLossReport() {
    this.appMainService.isShowSpinner('ProfitLossReport');
    this.reportService.allProfitLossReport(
      "profitandloss",
      this.formatDate(this.dateFrom),
      this.formatDate(this.dateTo)).subscribe({
        next: res => {
          this.appMainService.isHideSpinner('ProfitLossReport');
          console.log(res)
          this.profitReport = res;
          this.profitReport.forEach((s) => {
            this.expandedRows[s.financialAccountId] = true;
          });
          for (let s of this.profitReport) {
            if (s.financialAccountName.toLowerCase() == 'income') {
              this.totalIncome = s.balance;
            } else if (s.financialAccountName.toLowerCase() == 'expenses') {
              this.totalExpense = s.balance;
            } else {
              this.totalCOGS = s.balance;
            }
          }
          this.grossProfit = this.totalIncome - this.totalCOGS;
          this.netIncome = this.grossProfit - this.totalExpense;
        },
        error: (err) => {
          this.appMainService.isHideSpinner('ProfitLossReport');
          this.messageService.add({
            severity: "error",
            summary: "Error",
            detail: "Error occurred...",
          });
        }
      });
  }

  getBalanceSheet() {
    this.reportService.balanceSheetReport('balancesheet', this.formatDate(this.dateFrom), this.formatDate(this.dateTo))
      .subscribe({
        next: res => {
          if (res) {
            // this.profitReport = res;
            console.log(res);
          }
        },
        error: () => {

        }
      });
  }

  private formatDate(date: Date): any {
    //Convert to UTC time
    // let utcDate = this.app._saveDateTimeWithZone(date) ?? date;
    // return moment(utcDate).format('MM-DD-YYYY');

    let utcDate = this.datePipe.transform(this.app._saveDateTimeWithZone(date), "MM-dd-yyyy");
    return utcDate;
  }
  openBalanceDetail(c) {
    //console.log(c);
    this.first = 0;
    this.tranTemp = JSON.parse(JSON.stringify(c));
    let dateFilterType = DateFilterType.custom;
    let reportType = ReportType.Profitandlossdetaill;
    //this.displayBalanceDetail = true;
    this.appMainService.isShowSpinner('transactionDetails');
    this.financeService.financialTransactionDetail(this.formatDate(this.dateFrom), this.formatDate(this.dateTo), c.financialAccountId, this.pageNumber, this.pageSize, "", this.isAscending, "", "", dateFilterType, true, reportType)
      .then((res) => {
        this.appMainService.isHideSpinner('transactionDetails');
        let { inventory, headers } = res;
        inventory = inventory == null ? [] : inventory;
        headers = headers == null ? [] : headers;
        this.transactionDetails = inventory;
        this.totalDetailRecord = headers["TotalCount"];
        if (this.transactionDetails?.length > 0) {
          this.displayBalanceDetail = true;
        }
      },
        (err) => {
          this.appMainService.isHideSpinner("transactionDetails");
          this.messageService.add({
            severity: "error",
            summary: "Error",
            detail: "Error occurred...",
          });
        });
  }
  onRemoveFilter(selectedWindow: string, selectedFilters: IReportsFilterModel[]): void {
    this.onApplyFilter(selectedWindow, selectedFilters);
  }
  //when apply any filter
  onApplyFilter(selectedWindow: string, selectedFilters: IReportsFilterModel[]): void {
    this.selectedFilterVm = selectedFilters;
    this.applyFilter(selectedWindow, selectedFilters, 'apply');
  }
  //when Edit applied filter
  onModifyFilterOptions(selectedWindow: string, selectedFilters: IReportsFilterModel[]): void {
    this.applyFilter(selectedWindow, selectedFilters, 'modify');
  }
  //Apply Filter logic
  private applyFilter(selectedWindow: string, selectedFilters: IReportsFilterModel[], applyType: 'apply' | 'modify') {
    let reportsData = ParseHelper.DeepCopy(this.reportDatasCopy);
    if (applyType == 'apply') {
      this.reportDatas = ParseHelper.DeepCopy(reportsData);
    }
  }
  //When date filter dropdown change
  onChangeRange(selectedWindow: string, event: { dateFrom: any, dateTo: any }): void {
    this.dateFrom = event.dateFrom;
    this.dateTo = event.dateTo;
    this.getFinanceReportData();
  }
  onChangeChannel(selectedChannel: any) {
    this.selectedChannel = selectedChannel;
    this.getFinanceReportData();
  }
  openSetting() {
    this.displaySetting = true;
  }
  saveSettings() {

  }
  onPageChange(event) {
    this.pageNumber = event.first / event.rows + 1;
    this.pageSize = event.rows;
    this.first = event.first;
    this.openBalanceDetail(this.tranTemp);
  }
  onChangeOrderOption() {
    this.isAscending = this.selectedOrder == "asc";
    this.openBalanceDetail(this.tranTemp);
  }
}
